"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _variables = require("../../styles/variables");
var _HBCounter = require("./HBCounter.styles");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HBCounter = function HBCounter(_ref) {
  var id = _ref.id,
    name = _ref.name,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    value = _ref.value,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$showButtons = _ref.showButtons,
    showButtons = _ref$showButtons === void 0 ? true : _ref$showButtons,
    _ref$disabledTooltip = _ref.disabledTooltip,
    disabledTooltip = _ref$disabledTooltip === void 0 ? 'This value is immutable' : _ref$disabledTooltip,
    exceededMinTooltip = _ref.exceededMinTooltip,
    exceededMaxTooltip = _ref.exceededMaxTooltip,
    onChangeValue = _ref.onChangeValue,
    counterTargetContainerStyles = _ref.counterTargetContainerStyles,
    valueColor = _ref.valueColor,
    highlightColor = _ref.highlightColor,
    inputCustomTheme = _ref.inputCustomTheme,
    isInDrawer = _ref.isInDrawer;
  var hasMinValue = minValue != null;
  var hasMaxValue = maxValue != null;
  var _useState = (0, _react.useState)(function () {
      if (hasMinValue && value < minValue) {
        return minValue;
      }
      if (hasMaxValue && value > maxValue) {
        return maxValue;
      }
      return value;
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    customValue = _useState2[0],
    setCustomValue = _useState2[1];
  (0, _react.useEffect)(function () {
    setCustomValue(customValue);
  }, [customValue]);
  (0, _react.useEffect)(function () {
    setCustomValue(value);
  }, [value]);
  var handleOnChange = (0, _react.useCallback)(function (event) {
    var IS_FLOAT_REGEX = /^-?\d*(\.\d?\d?)?$/; // matches the following: 'd', 'd.','d.d', 'd.dd'
    if (new RegExp(IS_FLOAT_REGEX).test(event.target.value)) {
      setCustomValue(parseFloat(event.target.value));
    }
  }, []);
  var handleOnBlur = (0, _react.useCallback)(function (event) {
    var newValue = parseFloat(event.target.value);
    if (hasMinValue && newValue < minValue) {
      newValue = minValue;
    } else if (hasMaxValue && newValue > maxValue) {
      newValue = maxValue;
    }
    setCustomValue(newValue);
    onChangeValue(newValue);
  }, [hasMaxValue, hasMinValue, maxValue, minValue, onChangeValue]);
  var decreaseValue = (0, _react.useCallback)(function () {
    onChangeValue(customValue - 1);
    setCustomValue(customValue - 1);
  }, [customValue, onChangeValue]);
  var increaseValue = (0, _react.useCallback)(function () {
    onChangeValue(customValue + 1);
    setCustomValue(customValue + 1);
  }, [customValue, onChangeValue]);
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id || name,
    suffix: 'counter',
    componentName: 'HBCounter'
  });
  var renderButton = function renderButton(limitValue, mode, onClick, icon, tooltipText, counterTestId) {
    if (!showButtons) {
      return null;
    }
    var target = /*#__PURE__*/_react["default"].createElement(_HBCounter.ControlButtonContainer, {
      mode: mode,
      highlightColor: highlightColor,
      disabled: customValue === limitValue || disabled,
      onClick: disabled ? function () {} : onClick,
      isInDrawer: isInDrawer,
      "data-testid": "".concat(counterTestId, "-").concat(mode)
    }, icon);
    if (customValue !== limitValue) {
      return target;
    }
    return /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
      placement: "top",
      customStyle: {
        maxWidth: '212px',
        zIndex: _variables.Z_INDEX.TOP_MOST
      },
      target: target,
      targetContainerStyle: {
        height: '100%',
        margin: 0
      }
    }, tooltipText);
  };
  return /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
    forceClose: !disabled,
    customStyle: {
      maxWidth: '190px',
      zIndex: _variables.Z_INDEX.TOP_MOST
    },
    placement: "top",
    targetContainerStyle: _objectSpread(_objectSpread({}, counterTargetContainerStyles), {}, {
      height: '100%'
    }),
    target: /*#__PURE__*/_react["default"].createElement(_HBCounter.Container, null, /*#__PURE__*/_react["default"].createElement(_HBCounter.CounterContainer, {
      highlightColor: highlightColor,
      disabled: disabled,
      isInDrawer: isInDrawer
    }, renderButton(minValue, 'decrease', decreaseValue, isInDrawer ? /*#__PURE__*/_react["default"].createElement(_HBCounter.DecreaseDrawer, null) : /*#__PURE__*/_react["default"].createElement(_HBCounter.Decrease, null), exceededMinTooltip || "You must select at least ".concat(minValue), finalTestId), /*#__PURE__*/_react["default"].createElement(_HBCounter.InputValue, {
      id: id,
      name: name,
      type: "number",
      pattern: "[0-9]",
      size: "xs",
      value: customValue,
      disabled: disabled,
      customTheme: inputCustomTheme,
      onChange: disabled ? function () {} : handleOnChange,
      onBlur: disabled ? function () {} : handleOnBlur,
      min: minValue,
      max: maxValue,
      $valueColor: valueColor,
      $isInDrawer: isInDrawer,
      testId: finalTestId
    }), renderButton(maxValue, 'increase', increaseValue, isInDrawer ? /*#__PURE__*/_react["default"].createElement(_HBCounter.IncreaseDrawer, null) : /*#__PURE__*/_react["default"].createElement(_HBCounter.Increase, null), exceededMaxTooltip || "You can only select up to ".concat(maxValue), finalTestId)))
  }, disabledTooltip);
};
var _default = exports["default"] = HBCounter;
//# sourceMappingURL=HBCounter.js.map